import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { timed } from './timing';
import { limitToMaxSiteUsage } from './multi-site-utils';
import { batchMethod } from './api-batch';
import { getFetchProductPermissions } from './enabled-scopes';

// Type used to help unpack the types that make up an array

// Type used to lookup the response based on the scope

export var AggregatorClient = /*#__PURE__*/function () {
  function AggregatorClient(_ref) {
    var _this = this;
    var url = _ref.url,
      cloudId = _ref.cloudId,
      siteMasterList = _ref.siteMasterList,
      backendExperiment = _ref.backendExperiment;
    _classCallCheck(this, AggregatorClient);
    _defineProperty(this, "getAggregatorConfig", function () {
      return {
        url: _this.serviceConfig.url,
        cloudId: _this.cloudId,
        siteMasterList: _this.siteMasterList
      };
    });
    _defineProperty(this, "getGenericProductPermissions", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", getFetchProductPermissions(_this.makeGetRequest)(args.productIds, _this.cloudId, args.experience));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "batchedGetExtensibleProductPermission", batchMethod(function (args) {
      var emptyProductPermissions = {
        productIds: [],
        experience: ''
      };
      if (args.length === 0) {
        return emptyProductPermissions;
      }
      return args.reduce(function (acc, arg) {
        return {
          productIds: [].concat(_toConsumableArray(acc.productIds), _toConsumableArray(arg.productIds)),
          experience: arg.experience
        };
      }, emptyProductPermissions);
    }, this.getGenericProductPermissions, function (response, id) {
      return response.get(id) || [];
    }));
    _defineProperty(this, "makePostRequest", function (path, body) {
      var options = {
        path: path,
        requestInit: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }
      };
      return utils.requestService(_this.serviceConfig, options);
    });
    _defineProperty(this, "makeGetRequest", function (path) {
      var options = {
        path: path,
        requestInit: {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      };
      return utils.requestService(_this.serviceConfig, options);
    });
    this.serviceConfig = {
      url: url
    };
    this.cloudId = cloudId;
    this.siteMasterList = siteMasterList;
    this.backendExperiment = backendExperiment;
  }
  return _createClass(AggregatorClient, [{
    key: "getAbTestData",
    value: function () {
      var _getAbTestData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(scope, experience, product) {
        var body, response, scopeWithAbTest, abTestPromise;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              body = {
                cloudId: this.cloudId,
                scopes: [scope],
                experience: experience,
                product: product
              };
              _context2.next = 3;
              return this.makePostRequest(AggregatorClient.EXPERIMENT_URL_PATH, body);
            case 3:
              response = _context2.sent;
              scopeWithAbTest = response.scopes.find(function (s) {
                return s.id === scope;
              });
              abTestPromise = scopeWithAbTest ? Promise.resolve(scopeWithAbTest.abTest) : Promise.resolve(null);
              return _context2.abrupt("return", abTestPromise);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getAbTestData(_x2, _x3, _x4) {
        return _getAbTestData.apply(this, arguments);
      }
      return getAbTestData;
    }()
    /**
     * Get a list of permitted scopes for the supplied product.
     *
     * Consumers should favour {@link batchedGetExtensibleProductPermission}, to batch
     * multiple scopes calls into one. {@link getProductScopes} may be used when a caller
     * explicitly wants a separate REST call to fetch scopes. One example may be if a product
     * has different scopes caching rules to other products.
     *
     * @param productId the product id to lookup scopes for
     * @param experience the experience this UI represents
     * @returns a promise of a list of scopes for the supplied product
     */
  }, {
    key: "getProductScopes",
    value: (function () {
      var _getProductScopes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(productId, experience) {
        var productScopeMap;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getGenericProductPermissions({
                productIds: [productId],
                experience: experience
              });
            case 2:
              productScopeMap = _context3.sent;
              return _context3.abrupt("return", productScopeMap.get(productId) || []);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProductScopes(_x5, _x6) {
        return _getProductScopes.apply(this, arguments);
      }
      return getProductScopes;
    }()
    /**
     * Returns a list of {@link Products} which the user should see in the dialog
     *
     * @deprecated consumers should use {@link batchedGetExtensibleProductPermission} to fetch product scopes, or
     * {@link getProductScopes} to force a separate call to fetch a single product's scopes.
     *
     */
    )
  }, {
    key: "getProductPermissions",
    value: (function () {
      var _getProductPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(products, experience) {
        var lowercaseProductIds, productScopeMap;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              lowercaseProductIds = products.map(function (p) {
                return p.toLowerCase();
              });
              _context4.next = 3;
              return this.getGenericProductPermissions({
                productIds: lowercaseProductIds,
                experience: experience
              });
            case 3:
              productScopeMap = _context4.sent;
              return _context4.abrupt("return", lowercaseProductIds.filter(function (product) {
                var _productScopeMap$get;
                return (_productScopeMap$get = productScopeMap.get(product)) === null || _productScopeMap$get === void 0 ? void 0 : _productScopeMap$get.length;
              }).map(function (product) {
                return product.toUpperCase();
              }));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getProductPermissions(_x7, _x8) {
        return _getProductPermissions.apply(this, arguments);
      }
      return getProductPermissions;
    }())
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref3) {
        var _this$backendExperime, _this$backendExperime2;
        var query, context, scopes, modelParams, resultLimit, _ref3$filters, filters, experience, _ref3$sites, sites, sourceProduct, cloudId, cloudIdsToFilterOn, body, _yield$timed, response, requestDurationMs;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              query = _ref3.query, context = _ref3.context, scopes = _ref3.scopes, modelParams = _ref3.modelParams, resultLimit = _ref3.resultLimit, _ref3$filters = _ref3.filters, filters = _ref3$filters === void 0 ? [] : _ref3$filters, experience = _ref3.experience, _ref3$sites = _ref3.sites, sites = _ref3$sites === void 0 ? [] : _ref3$sites, sourceProduct = _ref3.sourceProduct;
              cloudId = this.cloudId;
              cloudIdsToFilterOn = sites.length > 0 ? sites : limitToMaxSiteUsage(this.siteMasterList).map(function (site) {
                return site.cloudId;
              });
              body = _objectSpread(_objectSpread({
                query: query,
                cloudId: cloudId,
                limit: resultLimit,
                scopes: scopes,
                filters: filters,
                searchSession: context
              }, modelParams.length > 0 ? {
                modelParams: modelParams
              } : {}), {}, {
                experience: experience,
                cloudIds: cloudIdsToFilterOn,
                experimentId: (_this$backendExperime = this.backendExperiment) === null || _this$backendExperime === void 0 ? void 0 : _this$backendExperime.experimentId,
                shadowExperimentId: (_this$backendExperime2 = this.backendExperiment) === null || _this$backendExperime2 === void 0 ? void 0 : _this$backendExperime2.shadowExperimentId
              }, sourceProduct ? {
                sourceProduct: sourceProduct
              } : {});
              _context5.next = 6;
              return timed(this.makePostRequest(AggregatorClient.QUICKSEARCH_API_URL, body));
            case 6:
              _yield$timed = _context5.sent;
              response = _yield$timed.result;
              requestDurationMs = _yield$timed.durationMs;
              return _context5.abrupt("return", {
                response: {
                  rawData: response,
                  retrieveScope: function retrieveScope(scope) {
                    return (
                      // @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                      response.scopes.find(function (s) {
                        return s.id === scope;
                      }) || null
                    );
                  }
                },
                requestDurationMs: requestDurationMs
              });
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function search(_x9) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
  }]);
}();
// Static URLs
_defineProperty(AggregatorClient, "EXPERIMENT_URL_PATH", 'experiment/v1');
_defineProperty(AggregatorClient, "QUICKSEARCH_API_URL", 'quicksearch/v1');